import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImport: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconImport"><Path d="M2.5 8.5V19.5H21.5V4.5H15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M2.5 4.5H7C9.76142 4.5 12 6.73858 12 9.5V15.25M12 15.25L15.75 11.5M12 15.25L8.25 11.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconImport;
